import { graphql } from "@opensea/graphql"
import { useToggleWatchTokenFragment } from "./use-toggle-watch-token.fragment"

export const CurrencyHeaderWatchlistButtonFragment = graphql(
  `
  fragment CurrencyHeaderWatchlistButton on Currency {
    contractAddress
    chainIdentifier
    ...useToggleWatchToken
  }
`,
  [useToggleWatchTokenFragment],
)
